export const PRODUCT_TEMPORAL = 0;
export const PRODUCT_COMPARE = 1;

export const PRODUCT_TEMPORAL_BY_ALERT = 0;
export const PRODUCT_TEMPORAL_BY_FORM = 1;

export const PRODUCT_COMPARE_BY_FORM = 0;
export const PRODUCT_COMPARE_SETTINGS = 1;
